import { Outlet } from 'react-router-dom';
import { ProfileHeader } from './components/profile-header.component';
import { PageListLayout } from '../../components/layout/page-list-layout';

export function ProfileLayout() {
  return (
    <PageListLayout>
      <ProfileHeader />
      <Outlet />
    </PageListLayout>
  );
}
